<template>
  <div class="main-content main-wrap">
    <div class="center-form">
      <img :src="require('~/assets/images/icon_fail.png')" width="120" height="120" />
      <p style="margin-top: 20px;
    font-size: 16px;
    line-height: 2;">您的人事账号审核未通过<br />
        原因：{{failReason}}</p>
    </div>
  </div>
</template>

<script>
  import {
    getValidFailReason
  } from '~/api/hr.js';
  export default {
    data() {
      return {
        failReason: ''
      };
    },
    created() {
      this.$emit('changeMenu', '');
      this.getFailReason();
    },
    methods: {
      getFailReason() {
        getValidFailReason().then(
          m => {
            if (m.errcode === 0) {
              this.failReason = m.data;
            }
          });
      }
    }
  };
</script>

<style>

</style>